/**
 * Decode Firebase Storage object path from a download URL (`.../o/<encoded>?...`).
 * @param {string | undefined} url
 * @returns {string | null}
 */
export function storageObjectPathFromDownloadUrl(url) {
  if (!url || typeof url !== 'string') return null;
  try {
    const u = new URL(url);
    const match = u.pathname.match(/\/o\/(.+)/);
    if (!match) return null;
    return decodeURIComponent(match[1].replace(/\+/g, ' '));
  } catch {
    return null;
  }
}
